<template>
  <div class="sectionTitleBar">
    <div class="sectionTitleBarLeft">
      <template v-if="sectionLinks">
        <div v-for="(link, index) in sectionLinks" :key="index" class="titleBarOption" v-bind:class="{ titleBarOptionSelected: link.selected}">
          <router-link :to="link.route" v-if="!link.selected">{{link.name}}</router-link>
          <span class="inactiveLink" v-else>{{link.name}}</span>
        </div>
      </template>
      <template v-if="sectionTitle">
        <div class="titleBarOption" >
          <span class="inactiveLink">{{sectionTitle}}</span>
        </div>
      </template>
    </div>
    <div class="sectionTitleBarRight">
      <button v-if="buttonText" @click='toggleFilterButton()' class="outlineButton">{{ buttonText }}</button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'sectionTitleBar',
  props: {
    sectionTitle: String,
    buttonText: String,
    sectionLinks: Array
  },
  methods: {
    toggleFilterButton: function(){
      this.$emit('buttonPress');
    }
  }
}
</script>

<style>
.sectionTitleBar {
  display: flex;
  font-size: 14px;
  width: 100%;
  align-items: center;
  height: 50px;
  display: flex;
  border-bottom: 2px solid #2E303A;
}
.sectionTitleBarLeft {
  margin-left: 15px;
  flex-grow: 1;
  display: flex;
}
.sectionTitleBar >div {
  height: 100%;
}
.sectionTitleBarRight {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 15px;
}
.titleBarOption{
  height: calc(100% - 2px);
  display: flex;
  align-items: center;
  margin-right: 15px;
}
.titleBarOptionSelected {
  border-bottom: 2px solid #6A7CE9;
}
</style>
